<template>
  <div>
    <NavCN/>
    <div class="main-container">
      <section class="middle-image">
        <img src="../../../public/img/background-product.jpg">
      </section>
      <section class="category-container">
        <div class="category-list">
          <div class="category-item" v-on:click="changeCategory('lacticAcid')">
            <img class="category-logo" src="../../../public/img/category/c01.png">
            <img class="category-name" src="../../../public/img/category/p01.jpg">
          </div >
          <div class="category-item" v-on:click="changeCategory('flavoursFragrance')">
            <img class="category-logo" src="../../../public/img/category/c02.png">
            <img class="category-name" src="../../../public/img/category/p02.jpg">
          </div>
          <div class="category-item" v-on:click="changeCategory('foodAdditives')">
            <img class="category-logo" src="../../../public/img/category/c03.png">
            <img class="category-name" src="../../../public/img/category/p03.jpg">
          </div>
          <div class="category-item" v-on:click="changeCategory('pharmacy')">
            <img class="category-logo" src="../../../public/img/category/c04.png">
            <img class="category-name" src="../../../public/img/category/p04.jpg">
          </div>
          <div class="category-item" v-on:click="changeCategory('plantEntract')">
            <img class="category-logo" src="../../../public/img/category/c05.png">
            <img class="category-name" src="../../../public/img/category/p05.jpg">
          </div>
        </div>
      </section>
      <section class="large-product-container">
        <div class="tittle-row">
          <div class="tittle">
            <div class="above-line"></div>
            <h5>产品展示</h5>
          </div>
        </div>
        <div class="product-list-container">
          <ul class="product-list">
            <li class="product-item" v-for="item in filterProductionList" :key="item.productNo">
              <div class="product-abstract" v-on:click="showProduct(item.productNo)">
                <img class="product-img" :src="item.productImage">
                <h5 class="product-tittle">{{item.productNameEn}}</h5>
                <h5 class="product-tittle">{{item.productNameCn}}</h5>
                <p class="product-spec"><b>Specification:</b> {{item.specification}}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="product-omit">
          <div v-if="listNum == 6" v-on:click="listNum=productList.length">More<img src="../../assets/arrow_down.svg"></div>
          <div v-else v-on:click="listNum = 6">Hide<img src="../../assets/arrow_up.svg">
          </div>
          <a v-if="listNum != 6">共{{productList.length}}条记录</a>
        </div>
      </section>
      <section class="detail-hide" :class="{'detail-show': productShowFlag}">
        <div class="detail-header" v-on:click="productShowFlag = false">
          <div class="closeBtn">x</div>
        </div>
        <div  class="detail-body">
          <div class="product-abstract">
            <img class="product-img" :src="productDetail.productImage">
            <h5 class="product-tittle">{{productDetail.productNameEn}}</h5>
            <h5 class="product-tittle">{{productDetail.productNameCn}}</h5>
            <h5 class="product-intro">Intro 产品简介：</h5>
            <p class="product-spec">{{productDetail.introEn}}</p>
            <p class="product-spec">{{productDetail.introCn}}</p>
          </div>
          <div class="product-detail">
            <div class="detail-tittle">SPECIFICATION 质量标准:</div>
            <div class="detail-list">
              <table>
                <thead>
                <tr>
                  <th>Item</th>
                  <th>Food Grade 食品级</th>
                  <th>Pharm Grade 药品级</th>
                </tr>
                </thead>
                <tbody>
                <tr class="detail-item" v-for="item in productDetail.list" :key="item.productNo">
                  <td>{{item.item}}</td>
                  <td>{{item.foodGrade}}</td>
                  <td>{{item.pharmGrade}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </section>
    </div>
    <FooterCN/>
  </div>
</template>

<script>

import NavCN from '@/components/nav-cn.vue'
import FooterCN from '@/components/footer-cn.vue'
import axios from 'axios'

export default {
  name: 'productCN',
  components: {
    NavCN,
    FooterCN
  },
  data () {
    return {
      category: 'lacticAcid',
      listNum: 6,
      productList: [],
      productDetail: [],
      productShowFlag: false
    }
  },
  mounted () {
    this.fetchParam()
    this.getProductList()
  },
  computed: {
    filterProductionList () {
      return this.productList.slice(0, this.listNum)
    }
  },
  methods: {
    fetchParam () {
      const getUrl = window.location.href
      if (getUrl.indexOf('?', 0) !== -1) {
        const params = getUrl.substring(getUrl.indexOf('?', 0) + 1).split('&')
        this.category = params[0].split('=')[1]
        const productNo = params[1].split('=')[1]
        this.showProduct(productNo)
      }
    },
    changeCategory (value) {
      this.category = value
      this.getProductList()
    },
    getProductList () {
      const jsonPath = '../../productJson/' + this.category + '.json'
      axios.get(jsonPath).then(res => {
        res = res.data
        this.productList = res.result.list
      })
    },
    showProduct (index) {
      const jsonPath = '../../productJson/' + this.category + '/' + index + '.json'
      axios.get(jsonPath).then(res => {
        res = res.data
        this.productDetail = res.result
      })
      this.productShowFlag = true
    }
  }
}
</script>

<style lang="scss">
  .main-container {
    position: relative;
    max-width: 1580px;
    margin: 0 auto;
    .middle-image {
      background: #333;
      width: 100%;
      height: 100%;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
        opacity: .7;
      }
    }
    .category-container {
      width: 100%;
      background-color: #fff;
      padding: 40px 0;
      .category-list {
        @media(min-width: 768px) {
          width: 750px;
        }
        @media(min-width: 992px) {
          width: 970px;
        }
        @media(min-width: 1200px) {
          width: 1170px;
        }
        margin: 0 auto;
        display: flex;
        .category-item {
          width: 20%;
          .category-logo {
            display: block;
            width: 60%;
            margin: 0 auto;
          }
          .category-name {
            display: block;
            width: 60%;
            margin: 0 auto;
          }
          &:hover {
            transform: translateY(-10%);
          }
        }
      }
    }
    .large-product-container {
      width: 100%;
      .tittle-row{
        @media(min-width: 768px) {
          width: 750px;
        }
        @media(min-width: 992px) {
          width: 970px;
        }
        @media(min-width: 1200px) {
          width: 1170px;
        }
        margin: 20px auto;
        height: 60px;
        .tittle {
          float: left;
          .above-line {
            width: 40px;
            height: 2px;
            background: #02328d;
            margin-bottom: 20px;
          }
          h5 {
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
            font-family: "Lucida Grande",Helvetica,Arial,"Microsoft YaHei",FreeSans,Arimo,"Droid Sans","wenquanyi micro hei","Hiragino Sans GB","Hiragino Sans GB W3",Roboto,Arial,sans-serif;
            margin-top: 0px;
            margin-bottom: 10px;
          }
        }
      }
      .product-list-container {
        @media(min-width: 768px) {
          width: 750px;
        }
        @media(min-width: 992px) {
          width: 970px;
        }
        @media(min-width: 1200px) {
          width: 1170px;
        }
        margin: 0 auto;
        display: flex;
        .product-list {
          position: relative;
          padding-inline-start: 0;
          list-style-type: none;
          .product-item {
            float: left;
            width: 100%;;
            @media(min-width: 768px) {
              width: 50%;
            }
            @media(min-width: 992px) {
              width: 33.33%;
            }
            .product-abstract {
              background-color: white;
              margin: 20px;
              padding: 30px;
              height: 350px;
              border: 3px solid white;
              &:hover {
                border: 3px solid #3eabb8;
              }
              .product-img {
                width: 200px;
                height: 200px;
                margin: 0 auto;
              }
              .product-tittle {
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
                margin: 10px auto;
                color: #3eabb8;
              }
              .product-spec {
                float: left;
                font-size: 14px;
                font-weight: 400;
                line-height: 24px;
                color: rgb(119, 119, 119)
              }
            }
          }
        }
      }
      .product-omit {
        font-size: 18px;
        line-height: 24px;
        margin: 10px auto;
        color: #3eabb8;
        img {
          width: 15px;
        }
        a {
          float: right;
        }
      }
    }
    .detail-hide {
      position: fixed;
      top: 15%;
      left: 20%;
      width: 60%;
      height: 70%;
      background-color: #f7f7f7;
      transform: translateY(20%);
      transition: all .2s ease-out;
      visibility: hidden;
      .detail-header {
        width: 100%;
        position: fixed;
        top: 0;
        .closeBtn {
          float: right;
          margin-right: 5px;
          width: 30px;
          height: 30px;
          font-size: 25px;
          color: #3eabb8;
          cursor: pointer;
        }
      }
      .detail-body {
        margin: 30px 10px;
        padding: 10px;
        height: 90%;
        overflow: auto;
        .product-abstract {
          padding: 10px 20px;
          .product-img {
            width: 200px;
            height: 200px;
            margin: 0 auto;
          }
          .product-tittle {
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
            margin: 10px auto;
            color: #3eabb8;
          }
          .product-intro {
            text-align: left;
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
            margin: 10px auto;
            color: #3eabb8;
          }
          .product-spec {
            text-align: left;
            text-indent: 2em;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            color: rgb(119, 119, 119)
          }
        }
        .product-detail {
          padding: 0 20px;
          .detail-tittle {
            text-align: left;
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
            margin: 10px auto;
            color: #3eabb8;
          }
          .detail-list {
            width: 100%;
            text-align: left;
            table {
              width: 100%;
              border: 1px solid #bcbcbc;
              border-collapse: collapse;
              border-spacing: 0;
              th {
                background-color: rgb(62, 171, 184);
                border: 1px solid #bcbcbc;
                font-size: 12px;
                font-weight: 400;
                color: white;
                padding: 5px 10px;
              }
              tr:nth-child(odd) {
                background-color: rgb(255, 255, 255);
              }
              tr:nth-child(even) {
                background-color: rgb(238, 238, 238);
              }
              td {
                border: 1px solid #bcbcbc;
                font-size: 12px;
                font-weight: 400;
                padding: 5px 10px;
                color: rgb(119, 119, 119);
              }
            };
          }
        }
      }
    }
    .detail-show {
      transform: translateY(0);
      visibility: visible;
    }
  }

</style>
